var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standard-modal',{attrs:{"title":"契約情報"},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('base-button',_vm._g({attrs:{"label":"契約書類情報"}},on))]}}]),model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('contract-documents-wrapper',{attrs:{"contract-period-id":_vm.contractId,"modal":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }